module.exports = __webpack_public_path__ + "img/ring_r_c_null_1@3x.0fbeb08d.png";